const hamburger = document.getElementById('main-header__hamburger');
const mainNav = document.getElementById('main-nav');
const menuItemButtons = document.querySelectorAll('.main-nav__menu-item--button > a');
const menuBackButtons = document.querySelectorAll('.main-nav__mega-menu-back-button');
const menuLinks = document.querySelectorAll('.main-nav li:not(.main-nav__sub-menu-item--card) > a');
const desktopCloseButton = document.getElementById('main-nav__mega-menu-desktop-close-button');
const subMenus = document.querySelectorAll('.main-nav__mega-menu-container > .sub-menu');
let resizeTimer;
let previousWindowSize = window.innerWidth;

const toggleHamburger = (e) => {
    e.preventDefault();
    e.currentTarget.blur();
    hamburger.classList.toggle('active');
    mainNav.classList.toggle('active');

    closeSubmenus();

    if (hamburger.classList.contains('active')) {
        addBodyClasses();
        document.addEventListener('keydown', closeMenuOnEsc);
    } else {
        removeBodyClasses();
    }
};

const closeHambuger = (e) => {
    hamburger.classList.remove('active');
    mainNav.classList.remove('active');
    removeBodyClasses();
};

const closeSubmenus = () => {
    menuItemButtons.forEach(button => {
        button.classList.remove('active');
    });

    if (document.body.classList.contains('sub-menu-open')) {
        document.body.classList.add('sub-menu-closing');
        document.body.classList.remove('sub-menu-open');
    }
    
    document.removeEventListener('keydown', closeMenuOnEsc);

    if (!hamburger.classList.contains('active')) {
        removeBodyClasses();
    }
                
    setTimeout(function() {
        if (!document.body.classList.contains('sub-menu-open')) {
            document.body.classList.add('sub-menu-closed');
            document.body.classList.remove('sub-menu-closing');
        }
    }, 400);
};

const addBodyClasses = (e) => {
    document.body.classList.add('mega-menu-open');
    document.body.classList.remove('scrolled-down', 'scrolled-up');

    if (menuLinks.length > 0) {
        menuLinks.forEach(link => {
            link.addEventListener('mouseenter', linkMouseEnter);
            link.addEventListener('mouseleave', linkMouseLeave);
        });
    }
};

const removeBodyClasses = (e) => {
    document.body.classList.remove('mega-menu-open', 'sub-menu-open', 'scrolled-up');
    document.body.classList.add('mega-menu-closing', 'mega-menu-closing-2');

    if (document.body.classList.contains('page-scrolled')) {
        document.body.classList.add('scrolled-up');
    }

    if (menuLinks.length > 0) {
        menuLinks.forEach(link => {
            link.removeEventListener('mouseenter', linkMouseEnter);
            link.removeEventListener('mouseleave', linkMouseLeave);
        });
    }
                
    setTimeout(function() {
        document.body.classList.remove('mega-menu-closing');
    }, 400);
                
    setTimeout(function() {
        document.body.classList.remove('mega-menu-closing-2');
    }, 800);
};

const toggleClass = (e) => {
    e.preventDefault();
    e.currentTarget.blur();

    if (e.currentTarget.classList.contains('active')) {
        e.currentTarget.classList.remove('active');
        removeBodyClasses();
    } else {
        closeSubmenus();
        document.body.classList.remove('sub-menu-closed');
        document.body.classList.add('sub-menu-open', 'sub-menu-opening');
        e.currentTarget.classList.add('active');
        document.addEventListener('keydown', closeMenuOnEsc);
        addBodyClasses();
                
        setTimeout(function() {
            document.body.classList.remove('sub-menu-opening');
        }, 400);
    }
};

const megaMenu = () => {
    setMegaMenuHeight();

    if (null !== hamburger && null !== mainNav) {
        hamburger.addEventListener('click', toggleHamburger);
    }

    if (desktopCloseButton) {
        desktopCloseButton.addEventListener('click', function(e) {
            e.preventDefault();
            closeSubmenus();
            closeHambuger();
        });
    }

    if (menuItemButtons.length > 0) {
        menuItemButtons.forEach(button => {
            button.addEventListener('click', toggleClass);
        });
    }

    if (menuBackButtons.length > 0) {
        menuBackButtons.forEach(button => {
            button.addEventListener('click', closeSubmenus);
        });
    }
};

const linkMouseEnter = (e) => {
    e.currentTarget.parentElement.parentElement.classList.add('menu-hovered-link');
};

const linkMouseLeave = (e) => {
    e.currentTarget.parentElement.parentElement.classList.remove('menu-hovered-link');
};

const setMegaMenuHeight = () => {
    if (subMenus.length) {
        let tallestSubMenuHeight = 0;
        let megaMenuHeight = 85;

        subMenus.forEach(subMenu => {
            if (subMenu.offsetHeight > tallestSubMenuHeight) {
                tallestSubMenuHeight = subMenu.offsetHeight;
            }
        });

        if (tallestSubMenuHeight > window.innerHeight * 0.85 - 220) {
            megaMenuHeight = (tallestSubMenuHeight + 220) / window.innerHeight * 100;

            if (megaMenuHeight > 100) {
                megaMenuHeight = 100;
            }
        }

        document.documentElement.style.setProperty(
            '--megaMenuHeight',
            `${megaMenuHeight}%`
        );
    }
};

const megaMenuResize = () => {
    if (((previousWindowSize >= 768 && window.innerWidth < 768) || (previousWindowSize < 768 && window.innerWidth >= 768)) && document.body.classList.contains('mega-menu-open')) {
        closeSubmenus();
        closeHambuger();
    }

    setMegaMenuHeight();

    document.body.classList.add('resizing');
    previousWindowSize = window.innerWidth;

    resizeTimer = setTimeout(function() {
        document.body.classList.remove('resizing');
    }, 400);
};

const closeMenuOnEsc = (e) => {
    if (e.key === 'Escape') {
        closeSubmenus();
        closeHambuger();
    }
};

export { megaMenu, megaMenuResize };